import { ca } from '@cian/analytics';

import { TAnalyticsOfferStatus, IAnalyticsExtraOfferIds } from '../../../../../../../types/analytics';
import { ITrackingPackageInfo, ETrackingSiteType } from './types';

interface ITrackParams {
  analyticsOfferStatus: TAnalyticsOfferStatus;
  analyticsExtraOfferIds: IAnalyticsExtraOfferIds;
  vas: string | null | undefined;
  siteType: ETrackingSiteType;
}

interface IRecommendedPackageTrackParams extends ITrackParams {
  packageInfo: ITrackingPackageInfo;
}

interface IRecommendedPackagesTrackParams extends ITrackParams {
  packagesInfo: ITrackingPackageInfo[];
}

export const trackDefaultPublicationClick = (params: ITrackParams) => {
  const { analyticsOfferStatus, analyticsExtraOfferIds, vas, siteType } = params;

  ca('eventSite', {
    name: 'oldevent',
    category: analyticsOfferStatus,
    action: 'publish_terms_block_click_sopr',
    label: 'announcement',
    page: {
      siteType,
      extra: {
        ...analyticsExtraOfferIds,
        package_block_default_value: 'announcement',
        vas,
      },
    },
  });
};

export const trackRecommendedPackageClick = (params: IRecommendedPackageTrackParams) => {
  const { analyticsOfferStatus, analyticsExtraOfferIds, vas, packageInfo, siteType } = params;

  ca('eventSite', {
    name: 'oldevent',
    category: analyticsOfferStatus,
    action: 'publish_terms_block_click_sopr',
    label: 'package',
    page: {
      siteType,
      extra: {
        ...analyticsExtraOfferIds,
        package_info: packageInfo,
        package_block_default_value: 'announcement',
        vas,
      },
    },
  });
};

export const trackShowRecommendedPackagesWidget = (params: IRecommendedPackagesTrackParams) => {
  const { analyticsOfferStatus, analyticsExtraOfferIds, vas, packagesInfo, siteType } = params;

  ca('eventSite', {
    name: 'oldevent',
    category: analyticsOfferStatus,
    action: 'publish_terms_block_show_sopr',
    label: 'package',
    page: {
      siteType,
      extra: {
        ...analyticsExtraOfferIds,
        package_info: packagesInfo,
        package_block_default_value: 'announcement',
        vas,
      },
    },
  });
};
